import { matrixMinMaxZ } from 'ml-spectra-processing';
/**
 * Those functions should disappear if add2D becomes accessible in jcampconvert
 * @param spectra
 * @returns {{z: Array<Array<number>>, minX: *, maxX: *, minY: *, maxY: *, minZ: *, maxZ: *}}
 */

export default function convertTo3DZ(datum) {
  const spectra = datum.spectra;

  // if (fileKeys.length === 0) {
  //   throw new Error('There is not data to extract');
  // }

  let ySize = spectra.length;
  let xSize = spectra[0].data.x.length;

  const firstX = spectra[0].data.x[0];
  const lastX = spectra[0].data.x[xSize - 1];
  const firstY = spectra[0].pageValue;
  const lastY = spectra[ySize - 1].pageValue;

  const minMax = {};
  const keyFiles = Object.keys(spectra[0].data).filter((key) => key !== 'x');
  for (const keyFile of keyFiles) {
    minMax[keyFile] = extractZMatrix(datum, {
      keyFile,
      ySize,
      firstX,
      lastX,
      firstY,
      lastY,
    });
  }
  return minMax;
}

function extractZMatrix(datum, options) {
  const spectra = datum.spectra;

  const { keyFile, ySize, firstX, lastX, firstY, lastY } = options;
  let z = new Array(ySize);

  for (let i = 0; i < ySize; i++) {
    z[i] = new Float64Array(spectra[i].data[keyFile]);
  }

  // Because the min / max value are the only information about the matrix if we invert
  // min and max we need to invert the array
  if (firstX > lastX) {
    for (let spectrum of z) {
      spectrum.reverse();
    }
  }
  if (firstY > lastY) {
    z.reverse();
  }

  let minMaxX =
    firstX < lastX
      ? { minX: firstX, maxX: lastX }
      : { minX: lastX, maxX: firstX };
  let minMaxY =
    firstY < lastY
      ? { minY: firstY, maxY: lastY }
      : { minY: lastY, maxY: firstY };

  const { min: minZ, max: maxZ } = matrixMinMaxZ(z);

  return {
    z,
    minZ,
    maxZ,
    ...minMaxX,
    ...minMaxY,
  };
}
